import { render, staticRenderFns } from "./ShareToEdit.vue?vue&type=template&id=ed3d8ac8&scoped=true"
import script from "./ShareToEdit.vue?vue&type=script&lang=js"
export * from "./ShareToEdit.vue?vue&type=script&lang=js"
import style0 from "./ShareToEdit.vue?vue&type=style&index=0&id=ed3d8ac8&prod&lang=scss&scoped=true"
import style1 from "./ShareToEdit.vue?vue&type=style&index=1&id=ed3d8ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3d8ac8",
  null
  
)

export default component.exports